import dynamic from 'next/dynamic';

import {withAuthentication} from '../../js/components/Routes';

const ReferralPage = withAuthentication(dynamic(
  () => import('../../js/pages/ReferralInfoPage'),
  {ssr: false},
));

export default ReferralPage;
